<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex flex-column flex-md-row justify-content-end mb-3 gap-3">
      <div class="order-md-2 order-1">
        <BBreadcrumb
          v-if="$route.meta.breadcrumb"
          :items="$route.meta.breadcrumb || []"
        />
      </div>
    </div>

    <BNav
      class="scrollable-x-tabs no-scrollbar nav-customer-memos-tabs gap-x-1"
      pills
    >
      <div class="nav-item">
        <div
          class="d-flex align-items-center position-absolute"
          style="padding: 2px 1px; height: 38px;"
        >
          <i
            class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
            style="font-size: 20px;"
          />
        </div>
      </div>

      <BNavItem
        :active="getActiveRoute('pending')"
        :to="{
          name: 'fso.to-dos.customer-memos.pending'
        }"
      >
        <i :class="iconState('fa-file-circle-question', getActiveRoute('pending'))" /> Pending
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('processing')"
        :to="{
          name: 'fso.to-dos.customer-memos.processing'
        }"
      >
        <i :class="iconState('fa-file-signature', getActiveRoute('processing'))" /> Processing
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('history')"
        :to="{
          name: 'fso.to-dos.customer-memos.history'
        }"
      >
        <i :class="iconState('fa-clock-rotate-left', getActiveRoute('history'))" /> History
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('documents')"
        :to="{
          name: 'fso.to-dos.customer-memos.documents'
        }"
      >
        <i :class="iconState('fa-file-pdf', getActiveRoute('documents'))" /> Documents
      </BNavItem>

      <div class="nav-item">
        <div
          class="d-flex align-items-center position-absolute"
          style="right: 20px; padding: 2px 1px; height: 38px;"
        >
          <i
            class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
            style="font-size: 20px;"
          />
        </div>
      </div>
    </BNav>

    <RouterView
      ref="tableView"
      @create:row="memo => $refs.memoCrud.createMemo(memo)"
      @edit:row="memo => $refs.memoCrud.editMemo(memo)"
      @view:row="memo => $refs.memoView.viewMemo(memo)"
    />

    <MemoCrud
      ref="memoCrud"
      @update:rows="() => $refs.tableView.api.refetch()"
      @update:row="memo => $refs.tableView.api.updateRow(memo)"
    />

    <MemoView
      ref="memoView"
    />
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MemoCrud from './components/MemoCrud.vue'
import MemoView from './components/MemoView.vue'

import MxMisc from '@/mixins/misc'

export default {
  name: 'FSOCustomerMemosBase',

  components: {
    MemoCrud,
    MemoView
  },

  mixins: [
    MxMisc
  ],

  middleware: [
    'auth',
    'fso'
  ],

  metaInfo: () => ({
    title: 'Customer Memos'
  }),

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  mounted () {
    if (this.currentUser) {
      this.$nextTick(() => {
        this.attachArrowScroller('.nav-customer-memos-tabs')
      })
    }
  },

  beforeDestroy () {
    this.detachArrowScroller('.nav-customer-memos-tabs')
  },

  methods: {
    getTabRoute (tabName) {
      return `/fso/to-dos/customer-memos/${tabName}`
    },

    getActiveRoute (tabName) {
      return this.$route.path === this.getTabRoute(tabName)
    }
  }
}
</script>
